import { FieldDetails } from '@openx/components-core/lib/FieldDetails/FieldDetails.tsx';
import { theme } from '@openx/components-core/lib/theme/theme.ts';
import { ACL_TYPE } from '@openx/types/aclType.ts';
import { usePermissionContext } from '@openx/utils/permission/context/PermissionContext.tsx';
import { isAllowedByCompiledAcl } from '@openx/utils/permission/validators.ts';
import { useMemo } from 'react';

import { DemandPartnerType } from '../../utils/participantFunctions.ts';

import { BrandsField } from './ParticipantBrandsField.tsx';
import type { ParticipantDefaultProps } from './types.ts';

export const ParticipantDefault = ({
  labels,
  getBuyerName,
  selectedSeatIds,
  selectedBrandIds,
  demandPartnerValue,
  enableDv360InventoryPackage,
  demandPartnerType,
  brands,
}: ParticipantDefaultProps) => {
  const { useIsAllowed } = usePermissionContext();
  const { isAllowed } = useIsAllowed();

  const seatNames = useMemo(() => {
    return selectedSeatIds.map(getBuyerName);
  }, [selectedSeatIds, getBuyerName]);

  const seatIDsDetails = useMemo(
    () => (
      <FieldDetails
        title={labels.seatIDs}
        value={seatNames}
        customStyles={{
          box: { borderLeft: `2px solid ${theme.palette.background.boxDarkest}`, paddingLeft: theme.spacing(2) },
        }}
      />
    ),
    [labels, seatNames]
  );
  const isDV360DemandPartner = useMemo(() => {
    return demandPartnerType === DemandPartnerType.DV360;
  }, [demandPartnerType]);

  return (
    <>
      <FieldDetails title={labels.demandPartner} value={demandPartnerValue} />
      {isDV360DemandPartner && isAllowed(isAllowedByCompiledAcl(ACL_TYPE.INTERNAL_FIELD_READ)) && (
        <FieldDetails toggle title={labels.enableForDV360IP} value={enableDv360InventoryPackage} />
      )}
      {seatIDsDetails}
      {brands && <BrandsField labels={labels} selectedBrandIds={selectedBrandIds} brands={brands} />}
    </>
  );
};
